var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCross(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 9,
    viewBox: "0 0 6 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.89697 8.60938L4.37297 5.04537C4.28897 4.84137 3.97697 4.64937 3.97697 4.64937C3.97697 4.64937 4.27697 4.46937 4.37297 4.24137L5.76497 0.929374H4.45697L3.43697 3.64137C3.37697 3.80937 3.13697 3.97737 3.13697 3.97737C3.13697 3.97737 2.90897 3.80937 2.84897 3.64137L1.82897 0.929374H0.508969L1.91297 4.24137C2.00897 4.45737 2.30897 4.64937 2.30897 4.64937C2.30897 4.64937 2.00897 4.82937 1.91297 5.04537L0.400969 8.60938H1.72097L2.84897 5.64537C2.90897 5.47737 3.14897 5.30937 3.14897 5.30937C3.14897 5.30937 3.38897 5.48937 3.44897 5.64537L4.58897 8.60938H5.89697Z",
    fill: "#8D8E92"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.81f76d7f07ea6278060491ca4be25e0a.svg";
export { ForwardRef as ReactComponent };